import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './rlink-apps-status.component'

let module = angular.module('rlinkAppsStatus', [
  uiRouter
])

.component('rlinkAppsStatus', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/rlink-apps-status/index.js